module.exports = __webpack_public_path__ + "img/LAST_ACTIVITIES.14266feb.svg";